import { z } from 'zod'

// `.catch(undefined)` coerces an invalid value (empty string, duplicated
// param → array) to `undefined` so ConsentScreen renders the friendly
// "invalid or expired" error instead of validateSearch throwing a ZodError
// into TanStack's raw default error boundary.
export const searchSchema = z.object({
  authorization_id: z.string().min(1).optional().catch(undefined),
})
